import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const App = () => {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    axios.get('./data.json')
      .then(response => {
        setCertificates(response.data);
        console.log(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div className="container">
      <h1 className="my-4">Certifications</h1>
      <div className="certifications-container">
        {certificates.map((cert, index) => (
          <div className="certification" key={index}>
            <h2>{cert.name}</h2>
            <div className="cert-details">
              <div className="left-column">
                <img src={`${process.env.PUBLIC_URL}/images/${cert.issuing_organization_logo}`} alt={cert.name} title={cert.name} className="logo" />
                <img src={`${process.env.PUBLIC_URL}/images/${cert.svg_logo}`} alt={cert.name} title={cert.name} className="svg_logo" />
              </div>
              <div className="main-column">
                <p><strong>Issuing Organization:</strong> {cert.issuing_organization}</p>
                <p><strong>Issue Date:</strong> {cert.month_of_issue_date} {cert.year_of_issue_date}
                  {cert.month_of_expiration_date && <span>, <strong>Expiration Date:</strong> {cert.month_of_expiration_date} {cert.year_of_expiration_date}</span>}
                </p>
                <p><strong>Credential ID:</strong> {cert.credential_id}</p>
                {cert.grade_level && <p><strong>Grade / Level:</strong> {cert.grade_level}</p>}
              </div>
              <div className="right-column">
                {cert.media_thumbnail_path && (
                  <a href={cert.credential_url} target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.PUBLIC_URL}/images/${cert.media_thumbnail_path}`} alt={cert.name} title={cert.name} className="media-thumbnail" />
                  </a>
                )}
                <a href={cert.credential_url} target="_blank" rel="noopener noreferrer">
                  <img src={`${process.env.PUBLIC_URL}/images/${cert.credential_id}.png`} alt={cert.name} title={cert.name} className="qrcode" />
                </a>
              </div>
            </div>
            <div className="extra-details">
              <p className="credential-url">
                <strong>Credential URL:</strong> <a href={cert.credential_url}>{cert.credential_url}</a>
              </p>
              {cert.sskills && (
                <p className="skills">
                  <strong>Skills:</strong> {cert.sskills}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default App;
